// extracted by mini-css-extract-plugin
export default {"container":"S02_PageTitle_container__6mJv1","limiter":"S02_PageTitle_limiter__G2kkM"};